export const paymentMethods = [
    { value: "alfamart", name: "Alfamart", src: "/images/payments/alfamart.png", },
    { value: "astrapay", name: "Astrapay", src: "/images/payments/astrapay.png" },
    { value: "bca", name: "Bank BCA", src: "/images/payments/bcabank.png" },
    { value: "bjb", name: "Bank BJB", src: "/images/payments/bjbbank.png" },
    { value: "bni", name: "Bank BNI", src: "/images/payments/bnibank.png" },
    { value: "bri", name: "Bank BRI", src: "/images/payments/bribank.png" },
    { value: "bsi", name: "Bank BSI", src: "/images/payments/bsibank.png" },
    { value: "btn", name: "Bank BTN", src: "/images/payments/btnbank.png" },
    { value: "bukopin", name: "Bank Bukopin", src: "/images/payments/bukopinbank.png" },
    { value: "cimb", name: "Bank CIMB", src: "/images/payments/cimbbank.png" },
    { value: "danamon", name: "Bank Danamon", src: "/images/payments/danamonbank.png" },
    { value: "gopay", name: "GoPay", src: "/images/payments/gopay.png" },
    { value: "indomaret", name: "Indomaret", src: "/images/payments/indomaret.png" },
    { value: "jago", name: "Bank Jago", src: "/images/payments/jagobank.png" },
    { value: "mandiri", name: "Bank Mandiri", src: "/images/payments/mandiribank.png" },
    { value: "maybank", name: "Maybank", src: "/images/payments/maybank.png" },
    { value: "mega", name: "Bank Mega", src: "/images/payments/megabank.png" },
    { value: "ovo", name: "OVO", src: "/images/payments/ovo.png" },
    { value: "permata", name: "Bank Permata", src: "/images/payments/permatabank.png" },
    { value: "qris", name: "QRIS", src: "/images/payments/qris.png" },
    { value: "shopeepay", name: "ShopeePay", src: "/images/payments/shopeepay.png" },
    { value: "other", name: "Other Bank", src: '/images/payments/bank.png' },
];

export const paymentMethodsMap = paymentMethods.reduce((acc, option) => {
    acc[option.value] = option;
    return acc;
}, {});

export const sdgProgram = [
    {
        name: "SDG 1",
        src: "/images/sdg/E-WEB-Goal-01.png",
        description:
            "Mendukung UMKM pernikahan dan menyediakan solusi terjangkau untuk mengurangi beban biaya.",
    },
    {
        name: "SDG 4",
        src: "/images/sdg/E-WEB-Goal-04.png",
        description:
            "Memberikan edukasi digital dan literasi teknologi bagi calon pengantin dan pelaku bisnis pernikahan.",
    },
    {
        name: "SDG 8",
        src: "/images/sdg/E-WEB-Goal-08.png",
        description:
            "Mendorong pertumbuhan ekonomi digital dan menciptakan peluang kerja yang layak di industri pernikahan.",
    },
    {
        name: "SDG 9",
        src: "/images/sdg/E-WEB-Goal-09.png",
        description:
            "Berinovasi dengan teknologi AI untuk platform pernikahan digital yang kuat dan inklusif.",
    },
    {
        name: "SDG 11",
        src: "/images/sdg/E-WEB-Goal-11.png",
        description:
            "Mendukung praktik pernikahan yang lebih ramah lingkungan dan mengurangi limbah fisik.",
    },
    {
        name: "SDG 12",
        src: "/images/sdg/E-WEB-Goal-12.png",
        description:
            "Mendorong konsumsi digital yang bertanggung jawab dan mengurangi jejak karbon pernikahan.",
    },
    {
        name: "SDG 13",
        src: "/images/sdg/E-WEB-Goal-13.png",
        description:
            "Berperan dalam aksi iklim melalui pengurangan limbah dan promosi solusi digital hijau.",
    },
    {
        name: "SDG 17",
        src: "/images/sdg/E-WEB-Goal-17.png",
        description:
            "Membangun kemitraan strategis untuk memperkuat ekosistem pernikahan digital yang berkelanjutan.",
    },
];

export const invitationFeatures = [
    { label: "Photo Gallery", description: "Bagikan momen prewedding kamu dan pasangan dalam galeri foto yang bisa dilihat oleh semua tamu dengan mudah dan elegan." },
    { label: "Maps/Location", description: "Tamu nggak perlu repot cari alamat, karena mereka bisa langsung klik dan diarahkan ke lokasi acara lewat Google Maps." },
    { label: "Request Music", description: "Musik pilihan kamu bisa diputar otomatis saat undangan dibuka, bikin suasana makin romantis dan personal." },
    { label: "Countdown Timer", description: "Tampilkan hitung mundur ke hari H sebagai pengingat sekaligus pemicu semangat menuju momen spesial kalian." },
    { label: "RSVP & Greeting", description: "Tamu bisa konfirmasi kehadiran dan kirim ucapan langsung lewat undangan tanpa perlu japri satu per satu." },
    { label: "Save The Date", description: "Cukup satu klik, tamu bisa simpan tanggal acara langsung ke kalender HP mereka biar nggak kelupaan." },
    { label: "Wedding Gift", description: "Fitur ini memudahkan tamu kasih hadiah secara digital, jadi nggak perlu repot bawa amplop fisik saat datang ke acara." },
    { label: "Video Prewedding", description: "Tampilkan video prewedding untuk memberikan kesan yang lebih hidup dan emosional kepada semua tamu." },
    { label: "Tracking Guest", description: "Pantau siapa aja yang sudah buka undangan kamu, jadi bisa lebih yakin pesanmu benar-benar sampai.", badge: "Free" },
    { label: "Love Story", description: "Ceritakan perjalanan cinta kalian dari awal bertemu sampai akhirnya memutuskan menikah, bikin undangan jadi lebih bermakna." },
    { label: "Link Personalisasi Tamu", description: "Kirim link unik dan personal ke setiap tamu, langsung terhubung dengan nama yang sudah terdaftar di buku tamu.", badge: "Free" },
    { label: "Scan QR Guest Book", description: "Buku tamu digital yang bisa diakses lewat scan QR code, jadi proses kehadiran lebih cepat dan rapi.", badge: "Free" },
];
